module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (addVariant) {;
__p += '\n    <span class="dropdown-toggle" data-toggle="dropdown"><i class="icon-plus"></i></span>\n';
} else if (firstVariant) {;
__p += '\n    <span class="create-locale">Language Variant</span>\n';
 } ;
__p += '\n\n<ul class="dropdown-menu">\n    ';
 _.each(locales, function (locale) {;
__p += '\n        <li>\n            <div class="variant-action" data-locale="' +
__e( locale.getLocaleString() ) +
'">\n                <span class="flag small ' +
__e( locale.getIdentifier() ) +
'"></span>' +
__e( locale.getVariantName() ) +
'\n            </div>\n        </li>\n    ';
 }); ;
__p += '\n</ul>\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/editor/LocaleSelectorControl.tpl
// module id = 2951
// module chunks = 0